import React, {useState} from "react";
import I18n from 'i18n.js.erb'
import {isLanguagePresent, isPresent} from "../../utils/utils";


const LanguageFlag = ({ language, maxHeight, cssClassList, displayRoundFlag, displayLanTxt, containerCssClassList }) => {

  return <React.Fragment>
    {
      isLanguagePresent(language) &&
        <div className={isPresent(containerCssClassList) ? containerCssClassList : 'd-flex'}>
          <img src={window.location.origin + `/images/${displayRoundFlag ? 'langs/' + language.toLowerCase() + '.svg' : 'flags/' + language.toLowerCase() + '.png'}`}
               style={{ height: maxHeight ? maxHeight : "20px" }}
               className={cssClassList ? cssClassList : "mb-1"}
               alt=""
          />
          {
            displayLanTxt &&
              <span className="text-wrap ml-2 text-truncate">
                { language !== 'native' ? language.toUpperCase() : I18n.t('js.editSubmissionListPage.webComponent.draft.labelLanguageOption.nativeCompact')}
              </span>
          }
        </div>
    }
  </React.Fragment>
};

export default LanguageFlag;